module.exports = __webpack_public_path__ + "ee8e23d9e80e4be9e0feb1e4b0d2faf2.png";